app.controller('CIFDashboard-CTRL', ['$scope', '$http', '$window', '$timeout', '$q', 'appFactory',
    function ($scope, $http, $window, $timeout, $q, appFactory) {

    $scope.CIFInvestor = {}
    $scope.page = '';

    $scope.datanasabah = function () {

        $window.location.href = "#/profile";
    }

    $scope.stepClass = ['', 'blur', 'blur', 'blur', 'blur'];

    $scope.active = "active current";

    $scope.imgMale = "";
    $scope.imgDoc = "";
    $scope.imgFemale = "";
    $scope.chkquestionfatca = 2;

    var allPromise = $q.all([

        $scope.retrieveSessions()
    ]);

    allPromise.then(function () {

        appFactory.getData(`/service/client.svc/getCIFDetail`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;

                    if ($scope.CIFInvestor.State1)
                        $scope.stepClass[1] = "active current";

                    if ($scope.CIFInvestor.State2)
                        $scope.stepClass[2] = "active current";

                    if ($scope.CIFInvestor.State3)
                        $scope.stepClass[3] = "active current";

                    if ($scope.CIFInvestor.State4)
                        $scope.stepClass[4] = "active current";

                    if ($scope.CIFInvestor.IsFinished == 1)
                        $scope.page = 'finished'

                    if ($scope.CIFInvestor.IsRevised == 1)
                        $scope.page = 'revised'
                }
            }
        })
    });

    $scope.login = function () {
        $window.location.href = "#/cif/data-pribadi";
    }
}]);